/**
 * UI Translations — static strings used in the interface
 * Menu content translations come from the restaurant's menu.json
 */
const translations = {
  en: {
    menu: "Menu",
    cart: "Cart",
    orderSummary: "Order Summary",
    total: "Total",
    addToOrder: "Add to Order",
    removeItem: "Remove",
    emptyCart: "Your cart is empty",
    emptyCartDesc: "Browse the menu and add items to get started",
    browseMenu: "Browse Menu",
    orderWhatsApp: "Order via WhatsApp",
    callUs: "Call Us",
    viewMenu: "View Menu",
    ingredients: "Ingredients",
    popular: "Popular",
    allCategories: "All",
    close: "Close",
    lightMode: "Light",
    darkMode: "Dark",
    quantity: "Qty",
    itemAdded: "Added to cart!",
    clearCart: "Clear All",
    back: "Back",
    searchPlaceholder: "Search menu...",
    noResults: "No items found",
    loading: "Loading menu...",
    errorLoading: "Couldn't load the menu. Please try again.",
    retry: "Retry",
    home: "Home",
    followUs: "Follow Us",
    address: "Address",
    currency: "MAD",
  },
  fr: {
    menu: "Menu",
    cart: "Panier",
    orderSummary: "Résumé de la Commande",
    total: "Total",
    addToOrder: "Ajouter",
    removeItem: "Supprimer",
    emptyCart: "Votre panier est vide",
    emptyCartDesc: "Parcourez le menu et ajoutez des articles",
    browseMenu: "Voir le Menu",
    orderWhatsApp: "Commander via WhatsApp",
    callUs: "Appelez-nous",
    viewMenu: "Voir le Menu",
    ingredients: "Ingrédients",
    popular: "Populaire",
    allCategories: "Tout",
    close: "Fermer",
    lightMode: "Clair",
    darkMode: "Sombre",
    quantity: "Qté",
    itemAdded: "Ajouté au panier !",
    clearCart: "Tout Effacer",
    back: "Retour",
    searchPlaceholder: "Rechercher...",
    noResults: "Aucun article trouvé",
    loading: "Chargement du menu...",
    errorLoading: "Impossible de charger le menu. Réessayez.",
    retry: "Réessayer",
    home: "Accueil",
    followUs: "Suivez-nous",
    address: "Adresse",
    currency: "MAD",
  },
  ar: {
    menu: "القائمة",
    cart: "السلة",
    orderSummary: "ملخص الطلب",
    total: "المجموع",
    addToOrder: "أضف للطلب",
    removeItem: "إزالة",
    emptyCart: "سلتك فارغة",
    emptyCartDesc: "تصفح القائمة وأضف أطباقك المفضلة",
    browseMenu: "تصفح القائمة",
    orderWhatsApp: "اطلب عبر واتساب",
    callUs: "اتصل بنا",
    viewMenu: "عرض القائمة",
    ingredients: "المكونات",
    popular: "رائج",
    allCategories: "الكل",
    close: "إغلاق",
    lightMode: "فاتح",
    darkMode: "داكن",
    quantity: "الكمية",
    itemAdded: "تمت الإضافة!",
    clearCart: "مسح الكل",
    back: "رجوع",
    searchPlaceholder: "بحث في القائمة...",
    noResults: "لم يتم العثور على أطباق",
    loading: "جاري تحميل القائمة...",
    errorLoading: "تعذر تحميل القائمة. حاول مرة أخرى.",
    retry: "إعادة المحاولة",
    home: "الرئيسية",
    followUs: "تابعنا",
    address: "العنوان",
    currency: "درهم",
  },
};

export default translations;
